import type { AxiosError } from "axios";

export interface ApiError extends Error {
  status?: number;
  response?: AxiosError["response"];
  retryAfterSeconds?: number;
  isAbort?: boolean;
}

export function axiosError(err: unknown): Error {
  const axiosErr = err as AxiosError<{
    message?: string;
    retryAfterSeconds?: number;
  }>;
  const status = axiosErr?.response?.status;
  const retryAfterHeader = axiosErr?.response?.headers?.["retry-after"];
  const retryAfterSeconds =
    retryAfterHeader !== undefined
      ? Number(retryAfterHeader)
      : Number(axiosErr?.response?.data?.retryAfterSeconds);
  if (status === 401) {
    // window.location.href = '/integrations/qbo/activate'
  }
  const data = axiosErr?.response?.data;
  const msg =
    typeof data === "string"
      ? data
      : data?.message || (err as Error).message || "Request failed";
  const apiError = new Error(
    status ? `HTTP ${status}: ${msg}` : msg,
  ) as ApiError;
  apiError.status = status;
  apiError.response = axiosErr?.response;
  apiError.retryAfterSeconds = Number.isFinite(retryAfterSeconds)
    ? Math.max(0, retryAfterSeconds)
    : undefined;
  apiError.isAbort =
    axiosErr?.code === "ERR_CANCELED" || (err as Error)?.name === "AbortError";
  return apiError;
}
